(function () {
	const sliderWithButtons = () => {
		$(".section-slider-with-buttons").each(function () {
			if ($(this).hasClass("slider_started")) {
				return "";
			}

			const id = $(this).attr("id");
			const swiperEl = $(this).find(".swiper");

			if (!swiperEl.length) {
				return "";
			}

			$(this).addClass("slider_started");

			new Swiper(`#${id} .swiper`, {
				slidesPerView: 1,
				spaceBetween: 0,
				loop: false,
				autoHeight: false,
				keyboard: true,
				navigation: {
					nextEl: `#${id} .swiper-button-next`,
					prevEl: `#${id} .swiper-button-prev`,
				},
			});
		});
	};

	document.addEventListener("DOMContentLoaded", function () {
		sliderWithButtons();
		document.addEventListener("shopify:section:load", function () {
			sliderWithButtons();
		});
	});
})();
